module.exports = require("core-js/modules/esnext.set.symmetric-difference.js");